import React, { Component } from "react";
import styles from "./logisticReports.module.scss";
import { withLogisticReports } from "../../../shared/containers/containerLogisticReport";
import { states } from "../../../reducers/queriesStates";
import Notification from "../../../shared/items/static/notification";
import Scrollbars from "react-custom-scrollbars-2";
import LogisticReportsTaskTripItem from "./LogisticReportsTaskTripItem";
import Preloader from "../../../shared/items/static/preloader";

class LogisticReportsTaskTrips extends Component {
  render() {
    const { getTaskTripsReportsDataState, taskTrips, onSetViewPanel } = this.props;

    const height = window.innerHeight > 800 ? 650 : 450;

    return (
      <div>
        <div className={styles.notificationContainer}>
          {getTaskTripsReportsDataState === states.READY && taskTrips.length === 0 ? (
            <Notification type="warning" styles={{ heigth: "40px" }}>
              <p>{`По заданным критериям не найдено данных о рейса`}</p>
            </Notification>
          ) : null}

          {getTaskTripsReportsDataState === states.REQUEST ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Preloader />
            </div>
          ) : null}
        </div>

        <div className={styles.logisticReportListContainer}>
          <Scrollbars style={{ height: `${height}px` }} autoHide={false} ref="scrollbar">
            {taskTrips.map((taskTrip) => {
              return <LogisticReportsTaskTripItem key={taskTrip.id} taskTrip={taskTrip} onSetViewPanel={onSetViewPanel} />;
            })}
          </Scrollbars>
        </div>
      </div>
    );
  }
}

export default withLogisticReports(React.memo(LogisticReportsTaskTrips));
